<dx-popup
    title="Time Entry"
    [width]="400"
    [height]="'auto'"
    [(visible)]="visible"
    [hideOnOutsideClick]="false"
    (onHiding)="onHiding($event)"
>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <dx-form [formData]="timeEntry" class="mb-4" validationGroup="mainValidationGroup">
        <dxi-form-item dataField="entryDate" editorType="dxDateBox">
            <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
        </dxi-form-item>
        <dxi-form-item
            dataField="userId"
            editorType="dxSelectBox"
            [editorOptions]="{ dataSource: users, valueExpr: 'userId', displayExpr: 'displayName' }"
            [label]="{ text: 'User' }"
        >
            <dxi-form-validation-rule type="range" [min]="1" message="Required"> </dxi-form-validation-rule>
            <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
        </dxi-form-item>
        <dxi-form-item
            dataField="timeTypeId"
            editorType="dxSelectBox"
            [editorOptions]="{ dataSource: timeTypes, valueExpr: 'id', displayExpr: 'name' }"
            [label]="{ text: 'Time Type' }"
        >
            <dxi-form-validation-rule type="range" [min]="1" message="Required"> </dxi-form-validation-rule>
            <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
        </dxi-form-item>
        <dxi-form-item dataField="duration" editorType="dxNumberBox">
            <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
        </dxi-form-item>
        <dxi-form-item dataField="description" editorType="dxTextArea" [editorOptions]="{ height: '50px' }"></dxi-form-item>
        <dxi-form-item dataField="notes" editorType="dxTextArea" [editorOptions]="{ height: '50px' }"></dxi-form-item>
    </dx-form>
</dx-popup>
